<template>
  <div class="modal fade" :data-backdrop="backdrop" :id="target" role="dialog" tabindex="-1">
    <div :class="classes" role="document">
      <div class="modal-content">
        <div v-if="hasSlot('header') || hasTitle()" class="modal-header">
          <template v-if="hasSlot('header')">
            <slot name="header" />
          </template>
          <h5 v-if="hasTitle()" class="modal-title">
            {{ title }}
          </h5>
          <button v-if="hasCloseButton" aria-label="Close" class="close" type="button" @click="$modal.close(id)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot />
        </div>
        <div v-if="hasSlot('footer')" class="modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',

  props: {
    hasCloseButton: Boolean,
    large: Boolean,
    primary: Boolean,
    secondary: Boolean,
    small: Boolean,
    static: Boolean,
    target: {
      required: true,
      type: String
    },
    title: String
  },

  computed: {
    backdrop () {
      if (this.static) {
        return 'static'
      }

      return true
    },

    classes () {
      return {
        'modal-dialog': true,
        'modal-lg': this.large,
        'modal-primary': this.primary,
        'modal-secondary': this.secondary,
        'modal-sm': this.small
      }
    },

    id () {
      return `#${this.target}`
    }
  },

  methods: {
    hasSlot (slot) {
      return this.$_.get(this.$slots, slot) !== undefined
    },

    hasTitle () {
      return this.title !== ''
    }
  }
}
</script>
